import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber4 = () => {
  return (
    <g>
      <path d="m5.917 8.569v.046h2.186v-2.876h-.046z" />
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.9562 9.48h-1.4727v2.1514h-1.3808v-2.1513h-3.4278v-1.1045l3.417-4.43h1.3916v4.4876h1.4727z" />
    </g>
  );
};

export default withIcon(IconNumber4);
